import { render, staticRenderFns } from "./approvalNoticeDetail.vue?vue&type=template&id=63bd89de&scoped=true&"
import script from "./approvalNoticeDetail.vue?vue&type=script&lang=js&"
export * from "./approvalNoticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./approvalNoticeDetail.vue?vue&type=style&index=0&id=63bd89de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd89de",
  null
  
)

export default component.exports